module.exports = __webpack_public_path__ + "static/img/Banner_600x300_std.7a9bb30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reproductive/Banner_600x300_std.jpg
// module id = Yx+E
// module chunks = 0